export default (t) => [
    {
        route: 'certificates.import.index',
        label: t('navigation.import_section'),
        showInSidebar: true
    }
]
